<template>
  <div v-if="allPageParamsSet&&currentPageNo>=1">
    <div v-if="isDebug" class="debug_str">TG/ExamInternalHeader currentPageNo={{ currentPageNo }}</div>

    <div class="row">
      <div class="col-12 px-2 px-sm-3 pager_wrapper d-flex flex-wrap">

        <template v-if="useQNoAsLabel">
          <div v-for="(pageParams, pageKey) in allPageParamsSet" :key="`page_${pageKey}`"
                class="pager_button_wrapper wide"
                :class="{ 'selected' : pageParams.page_no == currentPageNo }"
                @click.prevent="onMovePage(pageParams.page_no)"
          >
            <span class="pager_button my_18px">{{ pageParams.first_q_no }}～{{ pageParams.last_q_no }}</span>
          </div>
        </template>
        <template v-else>
          <div v-for="p in examinationPart.page_count" :key="`page_${p}`"
                class="pager_button_wrapper"
                :class="{ 'selected' : p == currentPageNo }"
                @click.prevent="onMovePage(p)"
          >
            <span class="pager_button my_18px">{{ p }}</span>
          </div>
        </template>

      </div>
    </div>

  </div>
</template>

<script>
const LogHeader = 'TG/ExamInternalHeader';
export default {
  props: {
    canEdit: { default: false }, // どの画面から呼ばれたかの判定に用いている（管理画面or（試験画面or解説画面））
    showDescription: { default: false }, // どの画面から呼ばれたかの判定に用いている（（管理画面or解説画面）or試験画面）
    examinationPart: { default: null },
    currentPageNo: { default: null }, // 1-
    tabLabel: { default: 'page_no' }, // page_no or question_no
    isDebug: { default: false },
  },
  // data() {
  //   console.log(`[${LogHeader}] data() CALLED`);
  //   return {
  //   };
  // },
  // created() {
  //   console.log(`[${LogHeader}] created() CALLED`);
  // },
  // mounted() {
  //   console.log(`[${LogHeader}] mounted() CALLED`);
  // },
  computed: {
    isEditPage() { return this.canEdit },
    isExamPage() { return !this.canEdit && !this.showDescription },
    isResultPage() { return !this.canEdit && this.showDescription },
    allPageParamsSet() { return this.examinationPart? this.examinationPart.all_page_params_set: null; },
    useQNoAsLabel() { return this.tabLabel=='question_no' && !!this.allPageParamsSet; },
  },
  methods: {
    onMovePage(pageNo) {
      console.log(`[${LogHeader}] onMovePage(${pageNo}) -> emitting(move-page, ${pageNo})`);
      this.$emit('move-page', pageNo);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../../../sass/_base"

$borderColor: #6F6F6F

.pager_wrapper
  border-bottom: 1px solid $borderColor
  .pager_button_wrapper
    &:not(.wide)
      width: 3.0em
    &.wide
      width: 6.0em
    line-height: 2.4em
    text-align: center
    &:hover
      cursor: pointer
      // text-decoration: underline
    &.selected
      border: 1px solid $borderColor
      // ↓ pager_wrapper のborder-bottomと重なった場合に、それを消すための設定
      border-bottom: 2px solid white
      margin-bottom: -1px
      // ↑
    .pager_button
      color: $colorTG
      font-weight: bold
</style>
